module.exports = __webpack_public_path__ + "img/smallLogo.fe27a5a6.jpg";